import { Point } from '@/types';

export function getVectorLength(differenceVector: Point) {
  return Math.sqrt(differenceVector.x ** 2 + differenceVector.y ** 2);
}
